import(/* webpackMode: "eager" */ "/snv/app/[locale]/error.js");
